import { ajax } from '@/util/ajax'

const BASE_URL = '/gateway/platform-oamapi/'

const DictionaryApi = {
  listDomainByCode (code, success, failure) {
    return ajax.get(
      BASE_URL + '/data-domain-value/list',
      { domainCode: code },
      success,
      failure
    )
  }
}

export { DictionaryApi }
